import * as React from "react";

import { formatDate, formatCurrency, formatSecure3d } from "app/utils/filters";
import BackOfficeAndSnapminLink from "app/components/BOComponents/BackOfficeAndSnapminLink";
import SnapminLink from "app/components/BOComponents/SnapminLink";
import { ColumnConfig } from "app/components/AppComponents/ConfigurableTable";
import BackOfficeLink from "app/components/BOComponents/BackOfficeLink";

const columnConfigs: ColumnConfig[] = [
  {
    name: "Date",
    render: (row) => (
      <BackOfficeLink
        backofficeUrl={`/snapscan/ops/payments/${row.reference}/summary`}
      >
        {formatDate(row.created_at)}
      </BackOfficeLink>
    ),
  },
  {
    name: "Payment token",
    render: (row) => row.payment_token,
  },
  {
    name: "Reference",
    render: (row) => (
      <BackOfficeLink
        backofficeUrl={`/snapscan/ops/payments/${row.reference}/summary`}
      >
        {row.reference}
      </BackOfficeLink>
    ),
  },
  {
    name: "Snapmin",
    render: (row) => <SnapminLink snapminUrl={row.snapmin_url} />,
  },
  {
    name: "Status",
    render: (row) => row.status,
  },
  {
    name: "Payable amount",
    cellProps: { align: "right" },
    render: (row) => `R${formatCurrency(row.payable_amount)}`,
  },
  {
    name: "Amount (Merchant)",
    cellProps: { align: "right" },
    render: (row) => `R${formatCurrency(row.merchant_amount)}`,
  },
  {
    name: "Service fee",
    cellProps: { align: "right" },
    render: (row) => `R${formatCurrency(row.user_fee_amount)}`,
  },
  {
    name: "Payment strategy",
    render: (row) => (
      <BackOfficeAndSnapminLink
        backofficeUrl={`/snapscan/ops/payments/${row.reference}/summary`}
        snapminUrl={row.snapmin_url}
      >
        {row.payment_strategy}
      </BackOfficeAndSnapminLink>
    ),
  },
  {
    name: "User",
    render: (row) => (
      <BackOfficeAndSnapminLink
        backofficeUrl={`/snapscan/ops/users/${row.device.user.external_reference}/payments`}
        snapminUrl={row.device.user.snapmin_url}
      >
        {row.device.user.email}
      </BackOfficeAndSnapminLink>
    ),
  },
  {
    name: "Merchant",
    render: (row) => (
      <BackOfficeAndSnapminLink
        backofficeUrl={`/snapscan/ops/merchants/${row.merchant.id}/payments`}
        snapminUrl={row.merchant.snapmin_url}
      >
        {row.merchant.name}
      </BackOfficeAndSnapminLink>
    ),
  },
  {
    name: "Device",
    render: (row) => (
      <BackOfficeAndSnapminLink
        backofficeUrl={`/snapscan/ops/devices/${row.device.external_reference}/summary`}
        snapminUrl={row.device.snapmin_url}
      >
        {row.device.phone_number}
      </BackOfficeAndSnapminLink>
    ),
  },
  {
    name: "Secure 3D",
    render: (row) => formatSecure3d(row.secure3d_requested),
  },
];

export default columnConfigs;
